/**
 * `items` through `fn`, at most `limit` at a time, the results in the items' order — for a list of
 * requests that would take too long one after another and would swamp the API all at once (the
 * repeat search's availability check per date: 26 Saturdays took 11 s in turn). The first failure
 * rejects it, and no item is started after that — a 401 halfway through a series sends no more.
 */
export async function mapLimited<T, R>(
  items: readonly T[],
  limit: number,
  fn: (item: T, index: number) => Promise<R>,
): Promise<R[]> {
  const results = new Array<R>(items.length);
  let next = 0;
  let failed = false;
  const worker = async () => {
    while (!failed && next < items.length) {
      const index = next++;
      try {
        results[index] = await fn(items[index], index);
      } catch (error) {
        failed = true;
        throw error;
      }
    }
  };
  await Promise.all(Array.from({ length: Math.min(limit, items.length) }, worker));
  return results;
}
